import React, { MouseEventHandler, useMemo } from "react";
import FlexBox from "../Box/FlexBox";
import Box from "../Box";
import { useSuiTheme } from "baseStyles/ThemeProvider";
interface IRadioButtonProps {
    selected: boolean;
    clickHandler?: MouseEventHandler<HTMLDivElement>;
    defaultAppearance?: boolean;
}
export const RadioButton = ({selected, clickHandler, defaultAppearance = true}: IRadioButtonProps) => {

  const {theme} = useSuiTheme();

  return (
    <FlexBox
      center
      height={16}
      width={16}
      borderRadius={8}
      border={`1px solid ${theme.radioButtonDefaultBorderColor}`}
      {...(!defaultAppearance ? {
        round: true,
        height: 20,
        width: 20,
        backgroundColor: theme.radioButtonBackgroundColor,
        border: `1.5px solid ${theme.radioButtonNewBorderColor}`,
        transition: "all .25s",
        hover: {
          boxShadow: `0px 0px 0px 6px ${theme.radioButtonBoxShadowColor}`
        }
      } : {})}
      {...(selected ? {
        border: `1px solid ${theme.radioButtonSelectedBorderColor}`,
        ...(!defaultAppearance ? {
          transition: "all .25s",
          hover: {
            boxShadow: 'none'
          }
        } : {})
      } : {})}
      onClick={clickHandler}
    >
      <Box 
        height={10} 
        width={10} 
        borderRadius={5}
        {...(selected ? {
          backgroundColor: theme.radioButtonSelectedBorderColor,
          ...(!defaultAppearance ? {
            backgroundColor: theme.radioButtonInnerBackgroundColor
          } : {})
        } : {})}
        {...(!defaultAppearance ? {
          height: 12,
          width: 12,
          borderRadius: 7
        } : {})}
      />
    </FlexBox>
  )
};